import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";

import IRoleWhitespace from "interfaces/models/IRoleWhitespace";

interface UserRoleItemProps {
  register : any;
  role: IRoleWhitespace;
}

const UserRoleItem = ({
  register, role, ...props
} : UserRoleItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center">
      <Col xs={11}><Form.Label className="d-flex w-100 mb-0" htmlFor={`swRole_${role.roleId}`}>{role.roleName}</Form.Label></Col>
      <Col xs={1} className="d-flex justify-content-end">
        <Form.Check
          {...register("roles")}
          id={`swRole_${role.roleId}`}
          data-testid={`swAllocate_${role.roleId}`}
          className="d-inline-flex custom-switch custom-switch-md ms-2"
          type="switch"
          aria-required="false"
          aria-label={`${role.roleName} role`}
          value={role.roleId}
        />
      </Col>
    </Row>
  </ListGroup.Item>
);

export default UserRoleItem;
